




























import { OrderResult } from '@/models/order/completed/order-result'
import { Order } from '@/models/order/order'
import OrderListItem from '@spa/components/pages/order/order/order-list/read-only/OrderListItem.vue'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    OrderListItem,
  },
})
export default class OrderResultList extends Vue {
  @Prop({ required: true })
  results: OrderResult[]

  genUniqueKey(order: Order): string {
    return order.cartItems.map(i => i.id).join('_')
  }
}
